import React from 'react';
import Link from '../atoms/link';

const Footer = ({
	pageDisclaimer = false
}) => {
	const pageDisclaimerContent = (pageDisclaimer) ? (
		<p>{pageDisclaimer}</p>
	) : null;

	return (
		<div className='co-footer'>
			<div className='co-footer__main'>
				<div className='l-container'>
					<div className='l-grid__row l-grid__middle-xs co-footer__logo-links'>
						<div className='l-grid__col-md co-footer__links--secondary'>
							<Link url='https://www.freedomdebtrelief.com/privacy-policy/' classNames='co-footer__link' target='_blank' external>
								Privacy Policy
							</Link>
							<Link url='https://www.freedomdebtrelief.com/terms/' classNames='co-footer__link' target='_blank' external>
								Terms of Use
							</Link>
							<Link url='https://www.freedomdebtrelief.com/contact/' classNames='co-footer__link' target='_blank' external>
								Contact Us
							</Link>
						</div>
					</div>
					<div className='l-grid__row'>
						<div className='l-grid__col-xs-12 l-spacing__m-t--24 co-footer__disclaimer'>
							{pageDisclaimerContent}
							<p>
								*Our estimates are based on prior results, which will vary depending on your specific enrolled creditors
								and your individual program terms. Not all clients are able to complete their program for various
								reasons, including their ability to save sufficient funds. We do not guarantee that your debts will be
								resolved for a specific amount or percentage or within a specific period of time. We do not assume your
								debts, make monthly payments to creditors or provide tax, bankruptcy, accounting or legal advice or
								credit repair services. Our service is not available in all states, including New Jersey, and our fees
								may vary from state to state. Please contact a tax professional to discuss potential tax consequences of
								less than full balance debt resolution. Read and understand all program materials prior to enrollment.
								The use of debt settlement services will likely adversely affect your creditworthiness, may result in
								you being subject to collections or being sued by creditors or collectors and may increase the
								outstanding balances of your enrolled accounts due to the accrual of fees and interest. However,
								negotiated settlements we obtain on your behalf resolve the entire account, including all accrued fees
								and interest. C.P.D. Reg. No. T.S.12-03825.
							</p>
						</div>
					</div>
				</div>
			</div>
			<div className='co-footer__copyright'>
				<div className='l-container'>
					<div className='l-grid__row'>
						<div className='l-grid__col-xs'>
							<p>&copy; Copyright {new Date().getFullYear()} Freedom Debt Relief. All rights reserved.</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer;
